import { render } from "./fourteen-blogs.vue?vue&type=template&id=b7653f7e"
import script from "./fourteen-blogs.vue?vue&type=script&lang=js"
export * from "./fourteen-blogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__